import { Box, Button, Checkbox, Divider, FormControl, FormLabel, Stack, Text } from "@chakra-ui/react";
import { ClaimService } from "../../utils/types";

interface HighFixedValueCaseStatusProps {
	service: ClaimService;
	serviceIndex: number;
	updateCaseStatus: (serviceIndex: number, field: string, value: boolean) => void;
}

const HighFixedValueCaseStatus = ({ service, serviceIndex, updateCaseStatus }: HighFixedValueCaseStatusProps) => {
	return (
		<Box p={4} mb={4}>
			<FormControl mb={4}>
				<FormLabel fontWeight="bold" mb={3}>
					Has the case reached a final disposition in court, mediation or settlement and has final documentation
					(decree, settlement agreement, bankruptcy filing, etc)?
				</FormLabel>
				<Stack direction="row" spacing={4}>
					<Button
						size="md"
						colorScheme={service.finalDisposition === true ? "orange" : "blackAlpha"}
						variant="solid"
						onClick={() => updateCaseStatus(serviceIndex, "finalDisposition", true)}>
						Yes
					</Button>
					<Button
						size="md"
						colorScheme={service.finalDisposition === false ? "orange" : "blackAlpha"}
						variant="solid"
						onClick={() => updateCaseStatus(serviceIndex, "finalDisposition", false)}>
						No
					</Button>
				</Stack>
			</FormControl>

			{service.finalDisposition === false && (
				<>
					<Divider mb={4} />
					<FormControl>
						<FormLabel fontWeight="bold" mb={3}>
							Then please select all your completed case work
						</FormLabel>
						<Stack spacing={3}>
							<Checkbox
								colorScheme="orange"
								isChecked={service.consultationCompleted}
								onChange={(e) => updateCaseStatus(serviceIndex, "consultationCompleted", e.target.checked)}>
								Consultation - 5%
							</Checkbox>
							<Checkbox
								colorScheme="orange"
								isChecked={service.officeWorkCompleted}
								onChange={(e) => updateCaseStatus(serviceIndex, "officeWorkCompleted", e.target.checked)}>
								Office Work (Document Review, Document Preparation, Research) - 15%
							</Checkbox>
							<Checkbox
								colorScheme="orange"
								isChecked={service.negotiationCorrespondenceCompleted}
								onChange={(e) =>
									updateCaseStatus(serviceIndex, "negotiationCorrespondenceCompleted", e.target.checked)
								}>
								Negotiation/Correspondence - 25%
							</Checkbox>
							<Checkbox
								colorScheme="orange"
								isChecked={service.lawsuitCaseFiledRespondedCompleted}
								onChange={(e) =>
									updateCaseStatus(serviceIndex, "lawsuitCaseFiledRespondedCompleted", e.target.checked)
								}>
								Lawsuit/Case Filed or Responded To - 50%
							</Checkbox>
							<Checkbox
								colorScheme="orange"
								isChecked={service.courtAppearanceCompleted}
								onChange={(e) => updateCaseStatus(serviceIndex, "courtAppearanceCompleted", e.target.checked)}>
								Court Appearance(s) - 80%
							</Checkbox>
							<Checkbox
								colorScheme="orange"
								isChecked={service.caseFullyCompleted}
								onChange={(e) => updateCaseStatus(serviceIndex, "caseFullyCompleted", e.target.checked)}>
								Case Completed, Resulting In Documented Final Disposition (Decree, Settlement Agreement, Judgment) -
								100%
							</Checkbox>
						</Stack>
					</FormControl>
				</>
			)}
		</Box>
	);
};

export default HighFixedValueCaseStatus;
